// extracted by mini-css-extract-plugin
export var searchHeader = "_29-0";
export var searchHeaderDark = "_29-1";